import React from "react";
import FileImportTable from "./FileImportTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const FileImportIndex = () => (
  <ReportProgramsPage
    TableComponent={FileImportTable}
    loadingMessage="Loading file import report..."
  />
);

export default FileImportIndex;
